import { render, staticRenderFns } from "./TabDelivered.vue?vue&type=template&id=0d26e3a8"
import script from "./TabDelivered.vue?vue&type=script&lang=js"
export * from "./TabDelivered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports